/* The drawer. Shell markup in snippets/sjt-cart-drawer.liquid, rendered on every
   page from snippets/optimizer.liquid -- layout/theme.liquid is 43,708 bytes and
   snippets/cart-drawer.liquid is 31,817, so neither can be pushed through the
   16,384-character cap. Injection is how the saved drawer reached the header too. */
(function () {
  'use strict';

  var SEL = '.sjd';
  var loaded = false;

  function panel() { return document.querySelector(SEL); }

  function setOpen(on) {
    var d = panel();
    if (!d) return;
    d.classList.toggle('is-open', on);
    d.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('overflow-hidden', on);
    if (on && !loaded) load();
  }

  /* One source of truth: the drawer renders the cart SECTION, so a change to
     sections/sjt-cart.liquid reaches both surfaces at once. */
  function load() {
    var d = panel();
    var body = d && d.querySelector('[data-sjd-body]');
    if (!body) return;
    body.innerHTML = '<p class="sjd__load">Loading your cart…</p>';
    fetch('/cart?section_id=sjt-cart', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) { body.innerHTML = '<p class="sjd__load">Could not load the cart.</p>'; return; }
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var sec = wrap.querySelector('[data-sjc]') || wrap;
        body.innerHTML = '';
        body.appendChild(sec);
        loaded = true;
        if (window.SjtCart && window.SjtCart.mount) window.SjtCart.mount(body);
      })
      .catch(function () { body.innerHTML = '<p class="sjd__load">Could not load the cart.</p>'; });
  }

  /* sjt-cart.js runs first (both deferred, in document order) so this is belt
     and braces -- but a drawer that throws on load takes the whole page's JS
     with it. */
  window.SjtCart = window.SjtCart || {};
  window.SjtCart.refresh = function () { loaded = false; load(); };

  /* The bag. Captured, so the theme's own handler never runs. */
  document.addEventListener('click', function (e) {
    var close = e.target.closest && e.target.closest('[data-sjd-close]');
    if (close) { e.preventDefault(); setOpen(false); return; }

    var bag = e.target.closest && e.target.closest('#cart-icon-bubble, .header__icon--cart');
    if (bag) { e.preventDefault(); e.stopPropagation(); loaded = false; setOpen(true); }
  }, true);

  document.addEventListener('keydown', function (e) {
    var d = panel();
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) setOpen(false);
  });

  /*
   * ADDING FROM A PRODUCT PAGE OPENS THE THEME'S DRAWER, not the bag. Bed, 4 Oct
   * 2026: "when i added to cart from product page and opened the cart page the
   * old cart cpeend". That open is triggered deep inside layout/theme.liquid,
   * which cannot be edited -- so instead we watch for it, shut it, and open ours.
   */
  function watchOld() {
    var old = document.querySelector('cart-drawer');
    if (!old) return;
    new MutationObserver(function () {
      if (old.classList.contains('active')) {
        old.classList.remove('active', 'animate');
        loaded = false;
        setOpen(true);
      }
    }).observe(old, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchOld);
  else watchOld();
})();